export default {
  ABSENCE: `Absence`,
  EARLY_OUT: `Early out`,
  LATE_ARRIVAL: `Late`,
  LEAVING: `Leaving`,
  LEAVING_AT: `Leaving at {{ departureTime }}`,
  ARRIVING: `Arriving`,
  ARRIVING_AT: `Arriving at {{ arrivalTime }}`,
  AT: 'at'
}
